import React, { useState, useEffect } from "react";
import { getAllCoupons, deleteCoupon } from "../Services/couponService";
import ConfirmationModal from "../Components/ConfirmationModal";
import { toast } from 'react-toastify';
import { RoutesPaths, options, customStyles } from "../Router/constant";
import { NavLink } from "react-router-dom";
import Select from 'react-select';
import Skeleton from '../Components/SkeletonLoader'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
export default function Couponmanagement() {
    const [couponData, setCouponData] = useState([]);
    const [offset, setOffset] = useState(1);
    const [limit] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [isActive, setIsActive] = useState("");
    const [confirmation, setConfirmation] = useState({
        show: false,
        couponId: null,
    });
    const [loading, setLoading] = useState(true);

    const [activeCouponCount, setActiveCouponCount] = useState(0);
    const [inactiveCouponCount, setInactiveCouponCount] = useState(0);
    const [totalCouponCount, setTotalCouponCount] = useState(0);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);


    const handleDeleteClick = (couponId) => {
        setConfirmation({ show: true, couponId });
    };

    const fetchAllData = async () => {
        setLoading(true); // start loader

        try {
            const queryParams = { offset, limit };
            if (isActive !== "") {
                queryParams.isActive = isActive;
            }
            if (startDate && endDate) {
                queryParams.fromDate = startDate.toISOString();
                queryParams.toDate = endDate.toISOString();
            }

            const couponsResp = await getAllCoupons(queryParams);
            const coupons = couponsResp.data?.data?.promos || [];
            setCouponData(coupons);
            setTotalCount(couponsResp.data?.data?.totalCount || 0);
            setActiveCouponCount(couponsResp?.data.data?.activeCount || 0);
            setInactiveCouponCount(couponsResp?.data.data?.inactiveCount || 0);
            setTotalCouponCount(couponsResp?.data.data?.totalCount || 0);

        } catch (error) {
            console.error("Error fetching coupons:", error);
            setCouponData([]);
        } finally {
            setLoading(false); // stop loader
        }
    };

    useEffect(() => {
        if (!startDate && !endDate) {
            fetchAllData();
        }

        if (startDate && endDate) {
            fetchAllData();
        }
    }, [offset, isActive, startDate, endDate]);



    const handleConfirmDelete = async () => {
        try {
            if (confirmation.couponId) {
                const response = await deleteCoupon(confirmation.couponId);
                if (response.data?.status === true) {
                    toast.success('Coupon Deleted Successfully');
                    fetchAllData();
                    setConfirmation({ show: false, couponId: null });
                } else {
                    console.error("Delete failed:", response.data?.message || "Unknown error");
                }
            }
        } catch (error) {
            console.error("Error deleting coupon:", error);
        }
    };


    const handleCancelDelete = () => {
        setConfirmation({ show: false, couponId: null });
    };


    return (
        <>
            <div className="container-fluid">
                <div className="row dashboardSection">
                    <div className="col-md-4">
                        <div className="bookingManagement">
                            <div>
                                {loading ? (
                                    <>
                                        <h6 className="m-0"><Skeleton width={60} /></h6>
                                        <p className="m-0"><Skeleton width={100} /></p>
                                    </>
                                ) : (
                                    <>
                                        <h6 className="m-0">{totalCouponCount}</h6>
                                        <p className="m-0">Total Coupons</p>
                                    </>
                                )}
                            </div>
                            <img src="/assets/img/totalBooking.png" alt=" " className="img-fluid" />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="bookingManagement">
                            <div>
                                {loading ? (
                                    <>
                                        <h6 className="m-0"><Skeleton width={60} /></h6>
                                        <p className="m-0"><Skeleton width={100} /></p>
                                    </>
                                ) : (
                                    <>
                                        <h6 className="m-0">{activeCouponCount}</h6>
                                        <p className="m-0">Active Coupons</p>
                                    </>
                                )}
                            </div>
                            <img src="/assets/img/unpaid.jpg" alt=" " className="img-fluid" />
                        </div>
                    </div>

                    <div className="col-md-4">
                        <div className="bookingManagement">
                            <div>
                                {loading ? (
                                    <>
                                        <h6 className="m-0"><Skeleton width={60} /></h6>
                                        <p className="m-0"><Skeleton width={120} /></p>
                                    </>
                                ) : (
                                    <>
                                        <h6 className="m-0">{inactiveCouponCount}</h6>
                                        <p className="m-0">Inactive Coupons</p>
                                    </>
                                )}
                            </div>
                            <img src="/assets/img/checkin.png" alt=" " className="img-fluid" />
                        </div>
                    </div>



                    <div className="col-md-12 bookingDetailsMain">
                        <div className="bookingDetailsOuter">
                            <div className="bookingDetailsAlign">
                                <h6 className="bookingDetailsTitle p-0">Coupon Details</h6>
                                <div className="bookingDetailsOuterRight uniform-gap">
                                    <div className="filterItem">
                                        <DatePicker
                                            selected={startDate}
                                            onChange={(date) => setStartDate(date)}
                                            placeholderText="From Date"
                                            isClearable={!!startDate}
                                            className="custom-datepicker filtercoupons"
                                        />
                                    </div>

                                    <div className="filterItem">
                                        <DatePicker
                                            selected={endDate}
                                            onChange={(date) => setEndDate(date)}
                                            placeholderText="To Date"
                                            isClearable={!!endDate}
                                            className="custom-datepicker filtercoupons"
                                        />
                                    </div>

                                    <div className="filterItem">
                                        <Select
                                            className="searchInputSelect filtercoupons"
                                            options={options}
                                            value={options.find((opt) => opt.value === isActive)}
                                            onChange={(selected) => setIsActive(selected.value)}
                                            styles={customStyles}
                                        />
                                    </div>

                                    <div className="filterItem">
                                        <NavLink to={`${RoutesPaths.ADDCOUPON}`} style={{ textDecoration: "none" }}>
                                            <button className="viewMoreCoupon">Add Coupon</button>
                                        </NavLink>
                                    </div>
                                </div>

                            </div>
                            <div className="TableOverFlow">
                                <div className="bookingContent bookingDetailsHeader">
                                    <div className="m-0 userNameWidth">Code</div>
                                    <div className="m-0 userNameWidth">Description</div>
                                    <div className="m-0 userNameWidth">Discount</div>
                                    <div className="m-0 userNameWidth">From Date</div>
                                    <div className="m-0 userNameWidth">To Date</div>
                                    <div className="m-0 userNameWidth">Min Order</div>
                                    <div className="m-0 userNameWidth">Type</div>
                                    <div className="m-0 couponUsageWidth">No. of usage</div>
                                    <div className="m-0 couponActionWidth">Action</div>
                                </div>

                                <div>
                                    {loading ? (
                                        [...Array(5)].map((_, i) => (
                                            <div className="bookingContent bookingContentData" key={i}>
                                                <div className="m-0 userNameWidth"><Skeleton width={80} /></div>
                                                <div className="m-0 userNameWidth"><Skeleton width={100} /></div>
                                                <div className="m-0 userNameWidth"><Skeleton width={60} /></div>
                                                <div className="m-0 userNameWidth"><Skeleton width={90} /></div>
                                                <div className="m-0 userNameWidth"><Skeleton width={90} /></div>
                                                <div className="m-0 userNameWidth"><Skeleton width={60} /></div>
                                                <div className="m-0 userNameWidth"><Skeleton width={70} /></div>
                                                <div className="m-0 couponUsageWidth"><Skeleton width={50} /></div>
                                                <div className="m-0 couponActionWidth"><Skeleton width={80} height={24} /></div>
                                            </div>
                                        ))
                                    ) : couponData.length > 0 ? (
                                        couponData.map((coupon, index) => (
                                            <div
                                                className={`bookingContent bookingContentData ${!coupon.isActive ? "disabled-row" : ""}`}
                                                key={coupon._id}
                                            >
                                                <div className="m-0 userNameWidth">{coupon.code}</div>
                                                <div className="m-0 userNameWidth">{coupon.description}</div>
                                                <div className="m-0 userNameWidth">{coupon.discount}</div>
                                                <div className="m-0 userNameWidth">{new Date(coupon.fromDate).toLocaleDateString("en-GB")}</div>
                                                <div className="m-0 userNameWidth">{new Date(coupon.toDate).toLocaleDateString("en-GB")}</div>
                                                <div className="m-0 userNameWidth">{coupon.minOrderValue}</div>
                                                <div className="m-0 userNameWidth">{coupon.type}</div>
                                                <div className="m-0 couponUsageWidth">{coupon.noOfUsage}</div>
                                                <div className="m-0 bookingActionButtons couponActionWidth position-relative">
                                                    {coupon.isActive ? (
                                                        <>
                                                            <NavLink to={`${RoutesPaths.ADDCOUPON}/${coupon._id}`} style={{ textDecoration: "none" }}>
                                                                <p className="m-0 editButton">
                                                                    <img src="/assets/img/editgrey.svg" alt="" /> Edit
                                                                </p>
                                                            </NavLink>
                                                            <p className="m-0 deleteIcon" onClick={() => handleDeleteClick(coupon._id)}>
                                                                <img src="/assets/img/delete-primary.svg" alt=" " /> Delete
                                                            </p>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <p className="m-0 editButton disabled-action">
                                                                <img src="/assets/img/editgrey.svg" alt="" /> Edit
                                                            </p>
                                                            <p className="m-0 deleteIcon disabled-action">
                                                                <img src="/assets/img/delete-primary.svg" alt=" " /> Delete
                                                            </p>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        ))
                                    ) : (
                                        <p className="noOrders">No coupon found</p>
                                    )}

                                </div>


                            </div>

                            {totalCount > 0 && Math.ceil(totalCount / limit) > 1 && (
                                <div className="paginationSection">
                                    <p
                                        onClick={() => offset > 1 && setOffset(offset - 1)}
                                        style={{
                                            opacity: offset > 1 ? 1 : 0.5,
                                            pointerEvents: offset > 1 ? "auto" : "none",
                                            cursor: offset > 1 ? "pointer" : "default"
                                        }}
                                    >
                                        <img src="/assets/img/arrow-left.svg" alt="Previous" />
                                    </p>

                                    {[...Array(Math.ceil(totalCount / limit))].map((_, index) => (
                                        <p
                                            key={index}
                                            onClick={() => setOffset(index + 1)}
                                            style={{
                                                fontWeight: offset === index + 1 ? "bold" : "normal",
                                                cursor: "pointer"
                                            }}
                                        >
                                            {index + 1}
                                        </p>
                                    ))}

                                    <p
                                        onClick={() => offset < Math.ceil(totalCount / limit) && setOffset(offset + 1)}
                                        style={{
                                            opacity: offset < Math.ceil(totalCount / limit) ? 1 : 0.5,
                                            pointerEvents: offset < Math.ceil(totalCount / limit) ? "auto" : "none",
                                            cursor: offset < Math.ceil(totalCount / limit) ? "pointer" : "default"
                                        }}
                                    >
                                        <img src="/assets/img/arrow-right.svg" alt="Next" />
                                    </p>
                                </div>
                            )}

                            <ConfirmationModal
                                show={confirmation.show}
                                title="Confirm Delete"
                                message="Are you sure you want to delete this user?"
                                onConfirm={handleConfirmDelete}
                                onCancel={handleCancelDelete}
                                confirmText="Yes, Delete"
                                cancelText="Cancel"
                            />

                        </div>
                    </div>
                </div>

            </div>
        </>
    );
}
